import { render, staticRenderFns } from "./BirthdaysPayments.vue?vue&type=template&id=60f2fef6&scoped=true&"
import script from "./BirthdaysPayments.vue?vue&type=script&lang=ts&"
export * from "./BirthdaysPayments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f2fef6",
  null
  
)

export default component.exports